export const STATIC_TO_SLIDE = [
  // "assets/banner/banner.jpg",
  "assets/banner/banner2.jpg",
  "assets/banner/banner3.jpg",
];
